import { Controller } from '@hotwired/stimulus';

// Fades in [data-reveal] elements as they scroll into view.
// Elements already on screen when the page loads are shown immediately.
// Automated browsers (crawlers, link previews, screenshots) never scroll, so they get the static page.
export default class extends Controller {
  connect() {
    if (navigator.webdriver) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const elements = this.element.querySelectorAll('[data-reveal]');
    const viewportBottom = window.innerHeight;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    elements.forEach((element) => {
      if (element.getBoundingClientRect().top < viewportBottom) {
        element.classList.add('is-visible');
      } else {
        this.observer.observe(element);
      }
    });

    this.element.classList.add('reveal-ready');
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
